import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

import { ANIMATIONS } from './animations.data';

/**
 * Animates show/hide elements
 *
 * @example
 * [@fadeAnimation]="true"
 *
 */
export const fadeAnimation: AnimationTriggerMetadata = trigger(
    'fadeAnimation', [
    state('true', style({
        opacity: 0,
        display: 'none'
    })),
    state('false', style({
        opacity: 1,
        display: 'block'
    })),
    transition('* => *', animate(`${ANIMATIONS.speed.default} ${ANIMATIONS.bezierCurve.default}`))
]);
